<style lang="scss">
@import '../assets/scss/_variables';

.svg-Electric path { stroke-dasharray: 1060; stroke-dashoffset: 1060; }
.svg-Mini path { stroke-dasharray: 640; stroke-dashoffset: 640; }
.svg-LuxuryCar path { stroke-dasharray: 855; stroke-dashoffset: 855; }
.svg-MediumCar path { stroke-dasharray: 835; stroke-dashoffset: 835; }
.svg-Other path { stroke-dasharray: 960; stroke-dashoffset: 960; }
.svg-SmallCar path { stroke-dasharray: 610; stroke-dashoffset: 610; }
.svg-SportsCar path { stroke-dasharray: 540; stroke-dashoffset: 540; }
.svg-SuvVehicle path { stroke-dasharray: 800; stroke-dashoffset: 800; }
.svg-Van path { stroke-dasharray: 1235; stroke-dashoffset: 1235; }

.vehicle-outlines {
    pointer-events: none;
}

.vehicle-illustration {
    max-width: 100%;
    pointer-events: auto;
    cursor: pointer;

    .cls-1, .cls-2, .cls-3 {
        fill: none;
        stroke: $color-illustrations;
        stroke-miterlimit: 10;
    }

    .cls-1 {
        stroke-width: 1.4px;
    }

    .cls-2 {
        stroke-width: 1px;
    }

    path {
        animation: dash 6s cubic-bezier(0, 0, 0.25, 1) forwards;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }
}

.vehicle-slide-enter {
    transform: translate(-30px, 0);
    opacity: 0;
}

.vehicle-slide-leave-to {
    transform: translate(120px, 0);
    opacity: 0;
}

.vehicle-slide-enter-active {
    transition:
        transform 1s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.7s ease;
}

.vehicle-slide-leave-active {
    transition:
        transform 1.4s cubic-bezier(0.77, 0, 0.175, 1),
        opacity 1s ease;
}
</style>

<template>
    <div class="vehicle-outlines">
        <transition name="vehicle-slide" mode="out-in">
            <component
                :is="illustration"
                :class="{
                    'vehicle-illustration': true,
                    ['svg-' + illustration]: true
                }"
                @click.native="showIllustration()"
            ></component>
        </transition>
    </div>
</template>

<script>
import Electric from '../assets/img/vehicles/electric.svg?inline';
import Mini from '../assets/img/vehicles/mini.svg?inline';
import LuxuryCar from '../assets/img/vehicles/luxury-car.svg?inline';
import MediumCar from '../assets/img/vehicles/medium-car.svg?inline';
import Other from '../assets/img/vehicles/other.svg?inline';
import SmallCar from '../assets/img/vehicles/small-car.svg?inline';
import SportsCar from '../assets/img/vehicles/sports-car.svg?inline';
import SuvVehicle from '../assets/img/vehicles/suv.svg?inline';
import Van from '../assets/img/vehicles/van.svg?inline';

var displayTimeout = null;

export default {
    components: {
        Electric,
        Mini,
        LuxuryCar,
        MediumCar,
        Other,
        SmallCar,
        SportsCar,
        SuvVehicle,
        Van
    },
    props: {
        interval: {
            type: Number,
            default: 7000
        }
    },
    data () {
        return {
            illustration: null
        };
    },
    created () {
        this.showIllustration();
    },
    methods: {
        showIllustration () {
            this.illustration = this.getRandomIllustration();

            clearTimeout(displayTimeout);
            displayTimeout = setTimeout(() => this.showIllustration(), this.interval);
        },
        getRandomIllustration () {
            var vehicles = Object.keys(this.$options.components),
                index = Math.floor(Math.random() * vehicles.length);

            if (index === vehicles.indexOf(this.illustration)) {
                index = ((index + 1) < vehicles.length) ? (index + 1) : 0;
            }

            return vehicles[index];
        }
    }
};
</script>
